// src/services/ArguenteDashboardService.js

import api from './api';
import defesaService from './defesaService';
import avaliacaoService from './avaliacaoService';
import { listarPropostas } from './propostaService'; // Importação correta

const ArguenteDashboardService = {
  async getDadosArguente() {
    try {
      // Usando Promise.all para fazer todas as chamadas em paralelo
      const [defesasResponse, avaliacoesResponse, propostasResponse] = await Promise.all([
        // Buscar apenas defesas onde o usuário é arguente
        defesaService.listarDefesasDoAvaliador('arguente'),
        
        // Buscar avaliações específicas do arguente
        avaliacaoService.listarAvaliacoes({
          papel: 'arguente'
        }),
        
        // Usar a função importada diretamente
        listarPropostas({
          papel: 'arguente'
        })
      ]);

      // Log para debug
      console.log('Dados recebidos - Defesas:', defesasResponse.data);
      console.log('Dados recebidos - Avaliações:', avaliacoesResponse.data);
      console.log('Dados recebidos - Propostas:', propostasResponse.data);

      return {
        defesas: defesasResponse.data || [],
        avaliacoes: avaliacoesResponse.data || [],
        propostas: propostasResponse.data || []
      };
    } catch (error) {
      console.error('Erro ao buscar dados do arguente:', error);
      // Retornar objeto vazio em caso de erro para evitar undefined
      return {
        defesas: [],
        avaliacoes: [],
        propostas: []
      };
    }
  }
};

export default ArguenteDashboardService;